import {
    Injectable,
    NgZone,
    OnDestroy,
} from '@angular/core';
import { AppStateFacade } from '@app-state';
import { ColorProvider } from '@components/ui-chart/chart-color-provider';
import { ColorService } from '@services/color/color.service';

import { Subscription } from 'rxjs';

@Injectable()
export class ThemeColorProvider extends ColorProvider implements OnDestroy {
    public textColor = '';
    public tooltipTextColor = '';
    public tooltipBackgroundColor = '';
    public legendTextColor = '';
    public legendInactiveColor = '';
    public axisTextColor = '';
    public axisLineColor = '';
    public gridLineColor = '';
    public axisHoverColor = '';

    private _themeSub: Subscription;

    constructor(
        appState: AppStateFacade,
        colorService: ColorService,
        zone: NgZone,
    ) {
        super(zone);

        this._themeSub = appState.user.theme.value$
            .subscribe(() => {
                this.textColor = colorService.theme.material.foreground.text;
                this.tooltipTextColor = colorService.theme.material.foreground.text;
                this.tooltipBackgroundColor = colorService.theme.uipath.tooltip;
                this.legendTextColor = colorService.theme.material.foreground.text;
                this.legendInactiveColor = colorService.theme.material.foreground.disabledText;
                this.axisTextColor = colorService.theme.material.foreground.text;
                this.axisLineColor = colorService.theme.material.foreground.divider;
                this.gridLineColor = colorService.theme.material.foreground.divider;
                this.axisHoverColor = colorService.theme.material.background.hover;

                this._changes.next();
            });
    }

    ngOnDestroy() {
        this.destroy();

        if (this._themeSub instanceof Subscription) {
            this._themeSub.unsubscribe();
        }
    }
}
